import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { SearchBarModule } from '../../../../../components/search-bar/search-bar.module';
import { NutritionTreeViewNodeModule } from './components/nutrition-tree-view-node/nutrition-tree-view-node.module';
import { NutritionViewLeafModule } from './components/nutrition-view-leaf/nutrition-view-leaf.module';
import { NutritionViewListNodeModule } from './components/nutrition-view-list-node/nutrition-view-list-node.module';
import { NutritionFoodLibraryComponent } from './nutrition-food-library.component';

@NgModule({
  declarations: [NutritionFoodLibraryComponent],
  imports: [
    CommonModule,
    AccordionModule,
    NgxBootstrapIconsModule,
    NutritionTreeViewNodeModule,
    NutritionViewListNodeModule,
    ReactiveFormsModule,
    FormsModule,
    SearchBarModule,
    NutritionViewLeafModule,
    DragulaModule,
  ],
  exports: [NutritionFoodLibraryComponent],
})
export class NutritionFoodLibraryModule {}
